function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5468FF",
  d: "M6.502 0h36.379c3.58 0 6.502 2.92 6.502 6.529v36.53c0 3.596-2.908 6.528-6.502 6.528H6.502C2.922 49.587 0 46.669 0 43.06V6.512C0 2.92 2.905 0 6.502 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.837 11.07v-1.7c0-1.189-.96-2.152-2.144-2.151h-4.998a2.148 2.148 0 00-2.144 2.15v1.746c0 .195.18.33.375.285a15.564 15.564 0 014.35-.615c1.426 0 2.837.194 4.201.57a.29.29 0 00.36-.285M16.14 13.295l-.854-.857a2.138 2.138 0 00-3.03 0l-1.021 1.022a2.147 2.147 0 000 3.04l.84.843c.135.134.33.103.45-.031a16.46 16.46 0 011.635-1.926 15.523 15.523 0 011.935-1.653c.15-.09.164-.302.045-.438m9.12 5.399v7.355c0 .21.227.362.42.256l6.513-3.384c.148-.074.193-.256.12-.405a8.097 8.097 0 00-6.752-4.107c-.15 0-.3.12-.3.285m0 17.719c-5.43 0-9.842-4.424-9.842-9.868s4.412-9.866 9.842-9.866c5.432 0 9.842 4.422 9.842 9.866s-4.395 9.868-9.842 9.868m0-23.884c-7.712 0-13.967 6.272-13.967 14.016 0 7.746 6.255 14.004 13.967 14.004 7.712 0 13.967-6.273 13.967-14.018 0-7.746-6.24-14.002-13.967-14.002"
})));

function SvgAlgoliaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgoliaLogo);
export default __webpack_public_path__ + "static/media/algolia-logo.8b893f6f.svg";
export { ForwardRef as ReactComponent };